import { render, staticRenderFns } from "./RadioaktifViewEmail.vue?vue&type=template&id=5dbc2d14&scoped=true&lang=pug&"
import script from "./RadioaktifViewEmail.vue?vue&type=script&lang=js&"
export * from "./RadioaktifViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./RadioaktifViewEmail.vue?vue&type=style&index=0&id=5dbc2d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc2d14",
  null
  
)

export default component.exports